"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _parse = require("parse");

var _parse2 = _interopRequireDefault(_parse);

var _Actions = require("../../Actions");

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require("../../utils/Utility");

var Utils = _interopRequireWildcard(_Utility);

var _SpinButton = require("../generic/SpinButton");

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _MainStore = require("../../stores/MainStore");

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteAddressModal = function (_React$Component) {
    _inherits(DeleteAddressModal, _React$Component);

    function DeleteAddressModal(props, context) {
        _classCallCheck(this, DeleteAddressModal);

        var _this = _possibleConstructorReturn(this, (DeleteAddressModal.__proto__ || Object.getPrototypeOf(DeleteAddressModal)).call(this, props, context));

        _this.state = {
            addressContainer: []
        };

        return _this;
    }

    _createClass(DeleteAddressModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            //bootstrap modal show on comp mount.
            $('#deleteModal').modal('show');
            $("#deleteModal").on('hidden.bs.modal', function () {
                _this2.props.onHide();
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            //hide modal if open while unmounting
            if ($('#deleteModal').hasClass('show')) {
                // The modal is open, so you can hide it
                $('#deleteModal').modal('hide');
            }
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                {
                    className: "modal fade",
                    id: "deleteModal", tabIndex: "-1", role: "dialog",
                    "aria-labelledby": "modalLabel", "aria-hidden": "true",
                    "data-keyboard": "false", "data-backdrop": "static"
                },
                _react2.default.createElement(
                    "div",
                    { className: "modal-dialog modal-dialog-centered modal-sm", role: "document" },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-content" },
                        _react2.default.createElement(
                            "div",
                            { className: "modal-header" },
                            _react2.default.createElement(
                                "h5",
                                { className: "modal-title", id: "delete-address" },
                                "Delete"
                            ),
                            _react2.default.createElement(
                                "button",
                                { type: "button", className: "close", "data-dismiss": "modal",
                                    "aria-label": "Close" },
                                _react2.default.createElement(
                                    "span",
                                    { "aria-hidden": "true" },
                                    "\xD7"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "modal-body" },
                            _react2.default.createElement(
                                "p",
                                { className: "mb-0 text-black" },
                                "Are you sure you want to delete?"
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "modal-footer" },
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: "d-flex swal2-confirm w-50 ft-14 font-weight-bold font-weight-bold text-center justify-content-center btn custom-btn-outline-primary",
                                buttonText: "CANCEL",
                                spinText: "",
                                showSpinner: false,
                                "data-dismiss": "modal",
                                showIcon: false,
                                iconClass: ""
                            }),
                            _react2.default.createElement(_SpinButton2.default, {
                                classNames: "btn btn-styl ft-14 font-weight-bold font-weight-bold w-50 text-center justify-content-center}",
                                buttonText: "DELETE",
                                spinText: "",
                                showSpinner: false,
                                whenClicked: this.props.callBackParent,
                                showIcon: false,
                                iconClass: ""
                            })
                        )
                    )
                )
            );
        }
    }]);

    return DeleteAddressModal;
}(_react2.default.Component);

exports.default = DeleteAddressModal;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DeleteAddressModal.jsx
// module id = 555
// module chunks = 0